import { Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';

@Component({
	selector: 'app-aws-quicksite',
	standalone: false,
	templateUrl: './aws-quicksite.component.html',
	styleUrl: './aws-quicksite.component.scss'
})
export class AwsQuicksiteComponent implements AfterViewInit {
	// @ViewChild('container', { static: true }) container!: ElementRef<HTMLDivElement>;

	ngAfterViewInit(): void {
		// const embedUrl = 'https://us-east-1.quicksight.aws.amazon.com/embed/2371648b8a1e4254ac8db7b9946ffeb0/dashboards/d2121d36-f92f-4a24-9ae7-fb19a72069b7?code=AYABeBV9NPjczqlNqRwHDKFliWsAAAABAAdhd3Mta21zAEthcm46YXdzOmttczp1cy1lYXN0LTE6MjU5NDgwNDYyMTMyOmtleS81NGYwMjdiYy03MDJhLTQxY2YtYmViNS0xNDViOTExNzFkYzMAuAECAQB42HF-xHeyR8SWG2ci7dp0XHnX-PgsyDaeZAM7ATifPbwBLnMhZi1Av5D_PiT-Hy9JOAAAAH4wfAYJKoZIhvcNAQcGoG8wbQIBADBoBgkqhkiG9w0BBwEwHgYJYIZIAWUDBAEuMBEEDMXiKw9eCIHeBWWsAAIBEIA7uTozN5NJOfyHX-r2x_bdkgyOZCA7dVQfRt0wLWdYRg8gSbkWpR7a4Q2wQN0qvu4KFq_fSzTsn5QG1wsCAAAAAAwAABAAAAAAAAAAAAAAAAAAAYm8TaRMjM9U4wcJVhOjlP____8AAAABAAAAAAAAAAAAAAABAAAAoY2mgt5Rriwb-o1UKC8idepFM26McepMoI8DW0HYsunGYgEHmdc_HT_gH1RiWIZii3BgTfO_2Og0IDFIHBQJgdFHAnnPLnIW0TpAc_3BwjOu0OziVQpRCMSegyoGfmHadDQr8c6t3k662dtwy1lhAoVTwodq2STm7cDjOSGx99ZatbwO-bO8zilw8aLFCUazyURYGZOlly3Acu1xMR5YABvWaGRwfWysAYxLHEXXbMq7Cg%3D%3D&identityprovider=quicksight&isauthcode=true';

		// const iframe = document.createElement('iframe');
		// iframe.src = embedUrl;
		// iframe.width = '100%';
		// iframe.height = '100%';
		// iframe.style.border = 'none';

		// this.container.nativeElement.appendChild(iframe);
	}
}
